module.exports = __webpack_public_path__ + "static/img/14003018.2a58411f.png";